module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"start":"Start","end":"End"},"de":{"start":"Start","end":"Ende"}}')
  delete Component.options._Ctor
}
